import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    textButton: {
        fontSize: 20,
        cursor: 'pointer',
        '&:hover': {
            color: '#2A5AFA'
        }
    },
    selected: {
        color: '#2A5AFA'
    }
}));

interface TextButtonProps extends TypographyProps {
    selected?: boolean;
}

const TextButton: React.FunctionComponent<TextButtonProps> = (props) => {
    const { selected } = props;
    const classes = useStyles();

    return (
        <Typography
            className={`${classes.textButton} ${selected && classes.selected}`}
            fontWeight={selected ? 700 : 500}
            {...props}
        >
            {props.children}
        </Typography>
    );
};

export default TextButton;
